<!--https://tailwindui.com/components/application-ui/application-shells/sidebar-->
<template>
  <div class="bg-cal-204285 from-cal-00194A to-cal-204285 bg-gradient-to-b text-white lg:flex lg:flex-col fixed inset-y-0 transition-all duration-200">
    <div class="">
      <div class="px-6 h-24 flex items-center justify-center">
        <router-link to="/Projects">
          <img src="/images/logo-reverse.svg" alt="Construct-A-Lead" v-if="open"/>
          <img src="/images/logo-icon.svg" class="w-12" alt="Construct-A-Lead" v-else/>
        </router-link>
      </div>
      <div v-if="!onUserProfile">
        <nav class="app-nav">
          <ul class="">
            <li>
              <router-link to="/Projects" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 22.953 22.957">
                  <path id="Icon_awesome-search" data-name="Icon awesome-search"
                        d="M22.641,19.848l-4.47-4.47a1.075,1.075,0,0,0-.762-.314h-.731a9.321,9.321,0,1,0-1.614,1.614v.731a1.075,1.075,0,0,0,.314.762l4.47,4.47a1.072,1.072,0,0,0,1.52,0l1.269-1.269A1.081,1.081,0,0,0,22.641,19.848ZM9.325,15.064a5.739,5.739,0,1,1,5.739-5.739A5.735,5.735,0,0,1,9.325,15.064Z"
                        fill="currentColor"/>
                </svg>
                <span :class="{'sr-only': !open}">Project Search</span>
              </router-link>
            </li>
            <li>
              <router-link to="/Calendar" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="nav-icon" :class="navIconClasses">
                  <path
                      d="M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32zM448 464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192H448V464z"
                      fill="currentColor"/>
                </svg>
                <span :class="{'sr-only': !open}">Calendar</span>
              </router-link>
            </li>
            <li class="my-projects">
              <vue-collapsible :classes="routerLinkClasses" :show-trigger="open">
                <router-link
                    slot="label"
                    class="flex items-center"
                    to="/Me/Projects">
                  <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 22.955 17.216">
                    <path id="Icon_awesome-hard-hat" data-name="Icon awesome-hard-hat"
                          d="M21.52,14.543a8.608,8.608,0,0,0-5.344-7.963l-1.83,3.659V5.217a.717.717,0,0,0-.717-.717h-4.3a.717.717,0,0,0-.717.717v5.021L6.778,6.579a8.608,8.608,0,0,0-5.344,7.963v2.869H21.52Zm.717,4.3H.717A.717.717,0,0,0,0,19.564V21a.717.717,0,0,0,.717.717h21.52A.717.717,0,0,0,22.955,21V19.564A.717.717,0,0,0,22.237,18.847Z"
                          transform="translate(0 -4.5)" fill="currentColor"/>
                  </svg>

                  <span :class="{'sr-only': !open}">Saved Projects</span>
                </router-link>

                <ul slot="content" class="bg-cal-204285 px-8 py-4 space-y-4">
                  <li v-for="tag in projectTags" class="tag-link-wrapper flex flex-row justify-between">
                    <router-link :to="'/Me/Projects/Tags/'+tag.id" class="tag-link flex flex-grow items-center space-x-2">
                      <status-block-circle :color="tag.color"></status-block-circle>
                      <span>{{ tag.name }}</span>
                    </router-link>
                    <div class="tag-link-edit" @click="editProjectTag(tag)">Edit</div>
                  </li>
                  <li>
                    <a class="cursor-pointer inline-flex space-x-2 items-center" @click="showProjectTagModal = true"
                       v-if="projectTags.length < 8">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 21.725 21.725">
                        <path id="Icon_awesome-plus-circle" data-name="Icon awesome-plus-circle"
                              d="M11.425.563A10.862,10.862,0,1,0,22.287,11.425,10.86,10.86,0,0,0,11.425.563Zm6.307,12.089a.527.527,0,0,1-.526.526h-4.03v4.03a.527.527,0,0,1-.526.526H10.2a.527.527,0,0,1-.526-.526v-4.03H5.643a.527.527,0,0,1-.526-.526V10.2a.527.527,0,0,1,.526-.526h4.03V5.643a.527.527,0,0,1,.526-.526h2.453a.527.527,0,0,1,.526.526v4.03h4.03a.527.527,0,0,1,.526.526Z"
                              transform="translate(-0.563 -0.563)" fill="currentColor"/>
                      </svg>

                      <span>Add Folder</span>
                    </a>
                  </li>
                </ul>
              </vue-collapsible>
            </li>
            <li v-if="$root.$data.auth.user.allowCompanySearch">
              <router-link to="/Companies" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 19.97 22.823">
                  <path id="Icon_awesome-building" data-name="Icon awesome-building"
                        d="M19.435,21.4h-.892V1.07A1.07,1.07,0,0,0,17.474,0H2.5a1.07,1.07,0,0,0-1.07,1.07V21.4H.535A.535.535,0,0,0,0,21.931v.892H19.97v-.892A.535.535,0,0,0,19.435,21.4ZM5.706,3.388a.535.535,0,0,1,.535-.535H8.024a.535.535,0,0,1,.535.535V5.171a.535.535,0,0,1-.535.535H6.241a.535.535,0,0,1-.535-.535Zm0,4.279a.535.535,0,0,1,.535-.535H8.024a.535.535,0,0,1,.535.535V9.45a.535.535,0,0,1-.535.535H6.241a.535.535,0,0,1-.535-.535Zm2.318,6.6H6.241a.535.535,0,0,1-.535-.535V11.946a.535.535,0,0,1,.535-.535H8.024a.535.535,0,0,1,.535.535v1.783A.535.535,0,0,1,8.024,14.264ZM11.411,21.4H8.559V17.652a.535.535,0,0,1,.535-.535h1.783a.535.535,0,0,1,.535.535Zm2.853-7.667a.535.535,0,0,1-.535.535H11.946a.535.535,0,0,1-.535-.535V11.946a.535.535,0,0,1,.535-.535h1.783a.535.535,0,0,1,.535.535Zm0-4.279a.535.535,0,0,1-.535.535H11.946a.535.535,0,0,1-.535-.535V7.667a.535.535,0,0,1,.535-.535h1.783a.535.535,0,0,1,.535.535Zm0-4.279a.535.535,0,0,1-.535.535H11.946a.535.535,0,0,1-.535-.535V3.388a.535.535,0,0,1,.535-.535h1.783a.535.535,0,0,1,.535.535Z"
                        fill="#81b920"/>
                </svg>

                <span :class="{'sr-only': !open}">Companies</span>
              </router-link>
            </li>
            <li v-if="$root.$data.auth.user.allowDirectory">
              <router-link to="/Contacts" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 27.022 21.018">
                  <path id="Icon_awesome-book-open" data-name="Icon awesome-book-open"
                        d="M25.438,2.252C22.867,2.4,17.757,2.929,14.6,4.86a.721.721,0,0,0-.341.618V22.549a.742.742,0,0,0,1.092.633c3.246-1.634,7.939-2.079,10.26-2.2a1.463,1.463,0,0,0,1.408-1.438V3.693a1.471,1.471,0,0,0-1.584-1.44ZM12.42,4.86C9.266,2.929,4.156,2.4,1.585,2.252A1.471,1.471,0,0,0,0,3.693v15.85a1.463,1.463,0,0,0,1.408,1.438c2.322.122,7.018.568,10.263,2.2a.74.74,0,0,0,1.089-.631V5.47A.706.706,0,0,0,12.42,4.86Z"
                        transform="translate(0 -2.25)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Directory</span>
              </router-link>
            </li>
            <li>
              <vue-collapsible :classes="routerLinkClasses" :show-trigger="open">
                <router-link
                    slot="label"
                    class="flex items-center"
                    to="/Me/Contacts">
                  <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 21.933 24.37">
                    <path id="Icon_material-perm-contact-calendar" data-name="Icon material-perm-contact-calendar"
                          d="M24,3.937H22.777V1.5H20.34V3.937H10.592V1.5H8.155V3.937H6.937A2.436,2.436,0,0,0,4.5,6.374V23.433A2.436,2.436,0,0,0,6.937,25.87H24a2.444,2.444,0,0,0,2.437-2.437V6.374A2.444,2.444,0,0,0,24,3.937ZM15.466,7.592a3.655,3.655,0,1,1-3.655,3.655A3.651,3.651,0,0,1,15.466,7.592Zm7.311,14.622H8.155V21c0-2.437,4.874-3.777,7.311-3.777s7.311,1.34,7.311,3.777Z"
                          transform="translate(-4.5 -1.5)" fill="currentColor"/>
                  </svg>

                  <span :class="{'sr-only': !open}">Contacts</span>
                </router-link>

                <ul slot="content" class="bg-cal-204285 px-8 py-4 space-y-4">
                  <li v-for="tag in contactTags" class="tag-link-wrapper flex flex-row justify-between">
                    <router-link :to="'/Me/Contacts/Tags/'+tag.id" class="tag-link flex flex-grow items-center space-x-2">
                      <status-block-circle :color="tag.color"></status-block-circle>
                      <span>{{ tag.name }}</span>
                    </router-link>
                    <div class="tag-link-edit" @click="editContactTag(tag)">Edit</div>
                  </li>
                  <li>
                    <a class="cursor-pointer inline-flex space-x-2 items-center" @click="showContactTagModal = true"
                       v-if="contactTags.length < 8">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 21.725 21.725">
                        <path id="Icon_awesome-plus-circle" data-name="Icon awesome-plus-circle"
                              d="M11.425.563A10.862,10.862,0,1,0,22.287,11.425,10.86,10.86,0,0,0,11.425.563Zm6.307,12.089a.527.527,0,0,1-.526.526h-4.03v4.03a.527.527,0,0,1-.526.526H10.2a.527.527,0,0,1-.526-.526v-4.03H5.643a.527.527,0,0,1-.526-.526V10.2a.527.527,0,0,1,.526-.526h4.03V5.643a.527.527,0,0,1,.526-.526h2.453a.527.527,0,0,1,.526.526v4.03h4.03a.527.527,0,0,1,.526.526Z"
                              transform="translate(-0.563 -0.563)" fill="currentColor"/>
                      </svg>
                      <span>Add folder</span>
                    </a>
                  </li>
                </ul>
              </vue-collapsible>
            </li>
            <li>
              <router-link to="/Notes" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="h4 w-4 mx-2 nav-icon" viewBox="0 0 22.955 20.085">
                  <path id="Icon_open-spreadsheet" data-name="Icon open-spreadsheet"
                        d="M2.152,0A2.168,2.168,0,0,0,0,2.152V17.933a2.168,2.168,0,0,0,2.152,2.152H20.8a2.168,2.168,0,0,0,2.152-2.152V2.152A2.168,2.168,0,0,0,20.8,0Zm.717,2.869H5.739V5.739H2.869Zm5.739,0H20.085V5.739H8.608ZM2.869,8.608H5.739v2.869H2.869Zm5.739,0H20.085v2.869H8.608ZM2.869,14.347H5.739v2.869H2.869Zm5.739,0H20.085v2.869H8.608Z"
                        fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Notes</span>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/Alerts" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="h4 w-4 mx-2 nav-icon" viewBox="0 0 20.086 22.955">
                  <path id="Icon_awesome-bell" data-name="Icon awesome-bell"
                        d="M10.043,22.955a2.869,2.869,0,0,0,2.868-2.869H7.175A2.869,2.869,0,0,0,10.043,22.955ZM19.7,16.243c-.866-.931-2.487-2.331-2.487-6.917a7.08,7.08,0,0,0-5.736-6.956V1.435a1.434,1.434,0,1,0-2.868,0v.934A7.08,7.08,0,0,0,2.873,9.325c0,4.586-1.621,5.987-2.487,6.917A1.4,1.4,0,0,0,0,17.216a1.436,1.436,0,0,0,1.439,1.435H18.646a1.436,1.436,0,0,0,1.439-1.435A1.4,1.4,0,0,0,19.7,16.243Z"
                        transform="translate(0)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Alerts</span>
              </router-link>
            </li> -->
            <li class="px-6 mt-4" v-if="open">
              <button class="px-3 py-2 bg-cal-81B920 text-white uppercase text-sm inline-flex w-full space-x-2"
                      @click.prevent="toggleKeywordSearch">
              <span class="fill-white w-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.953 22.957">
                  <path
                      d="M22.641,19.848l-4.47-4.47a1.075,1.075,0,0,0-.762-.314h-.731a9.321,9.321,0,1,0-1.614,1.614v.731a1.075,1.075,0,0,0,.314.762l4.47,4.47a1.072,1.072,0,0,0,1.52,0l1.269-1.269A1.081,1.081,0,0,0,22.641,19.848ZM9.325,15.064a5.739,5.739,0,1,1,5.739-5.739A5.735,5.735,0,0,1,9.325,15.064Z"/>
                </svg>
              </span>
                <span class="text-left">Keyword <span>Search</span></span>
              </button>
            </li>


            <div v-if="this.user.memberType == 'Free Trial'" class="trial-info">
              {{ this.user.subscription.remaining_projects }} Free Reports Remaining.<br><br>Expires
              On:<br>{{ this.user.trialEndDate }}
            </div>

<!--            <li class="lg:hidden">-->
<!--              <a href="#" :class="routerLinkClasses" @click.prevent="showContactUs = true">Ask A Question</a>-->
<!--            </li>-->
<!--            <li class="lg:hidden">-->
<!--              <a href="#" :class="routerLinkClasses" @click.prevent="showRequestResearch = true">Request Research</a>-->
<!--            </li>-->
<!--            <li class="lg:hidden">-->
<!--              <router-link to="/Help" :class="routerLinkClasses">Help Center</router-link>-->
<!--            </li>-->
<!--            <li class="lg:hidden">-->
<!--              <router-link to="/Manual" :class="routerLinkClasses">Manual</router-link>-->
<!--            </li>-->
            <li class="lg:hidden">
              <router-link to="/Me/Account" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 20.406 20.406">
                  <path id="Icon_ionic-md-person" data-name="Icon ionic-md-person"
                        d="M14.7,14.7A5.1,5.1,0,1,0,9.6,9.6,5.116,5.116,0,0,0,14.7,14.7Zm0,2.551c-3.38,0-10.2,1.722-10.2,5.1v2.551H24.906V22.355C24.906,18.976,18.083,17.254,14.7,17.254Z"
                        transform="translate(-4.5 -4.5)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Account</span>
              </router-link>
            </li>
            <li class="lg:hidden">
              <router-link to="/Me/Logout" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 20.562 17.992">
                  <path id="Icon_open-account-logout" data-name="Icon open-account-logout"
                        d="M7.711,0V2.57H17.992V15.422H7.711v2.57H20.562V0ZM5.141,5.141,0,9l5.141,3.855v-2.57H15.422V7.711H5.141Z"
                        fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Logout</span>
              </router-link>
            </li>
          </ul>
        </nav>
        <tag-modal-view
            ref="projectTag"
            :show="showProjectTagModal"
            type="project"
            @on-close="showProjectTagModal = !showProjectTagModal"
            @on-save="reloadTags()">
        </tag-modal-view>
        <tag-modal-view
            ref="contactTag"
            :show="showContactTagModal"
            type="contact"
            @on-close="showContactTagModal = !showContactTagModal"
            @on-save="reloadTags()">
        </tag-modal-view>
      </div>
      <div v-else>
        <nav class="app-nav">
          <ul>
            <li>
              <router-link to="/Projects" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 19.92 19.92">
                  <path id="Icon_awesome-arrow-alt-circle-left" data-name="Icon awesome-arrow-alt-circle-left"
                        d="M10.522,20.482a9.96,9.96,0,1,1,9.96-9.96A9.958,9.958,0,0,1,10.522,20.482ZM15.181,8.755H10.522V5.908A.482.482,0,0,0,9.7,5.567l-4.59,4.614a.478.478,0,0,0,0,.679L9.7,15.474a.482.482,0,0,0,.823-.341V12.289h4.659a.483.483,0,0,0,.482-.482V9.237A.483.483,0,0,0,15.181,8.755Z"
                        transform="translate(-0.563 -0.563)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Back</span>
              </router-link>
            </li>
            <li>
              <router-link to="/Me/Account" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 20.406 20.406">
                  <path id="Icon_ionic-md-person" data-name="Icon ionic-md-person"
                        d="M14.7,14.7A5.1,5.1,0,1,0,9.6,9.6,5.116,5.116,0,0,0,14.7,14.7Zm0,2.551c-3.38,0-10.2,1.722-10.2,5.1v2.551H24.906V22.355C24.906,18.976,18.083,17.254,14.7,17.254Z"
                        transform="translate(-4.5 -4.5)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Account</span>
              </router-link>
            </li>
            <li>
              <router-link to="/Me/Subscription" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 20.562 20.563">
                  <path id="Icon_awesome-envelope-open-text" data-name="Icon awesome-envelope-open-text"
                        d="M7.068,8.675h6.426a.642.642,0,0,0,.643-.643V7.39a.642.642,0,0,0-.643-.643H7.068a.642.642,0,0,0-.643.643v.643A.642.642,0,0,0,7.068,8.675Zm-.643,3.213a.642.642,0,0,0,.643.643h6.426a.642.642,0,0,0,.643-.643v-.643a.642.642,0,0,0-.643-.643H7.068a.642.642,0,0,0-.643.643Zm3.855,4.865a3.208,3.208,0,0,1-1.882-.61L0,10.075v8.56a1.928,1.928,0,0,0,1.928,1.928H18.635a1.928,1.928,0,0,0,1.928-1.928v-8.56l-8.4,6.068A3.211,3.211,0,0,1,10.281,16.752ZM19.824,6.544c-.355-.279-.692-.541-1.189-.916V3.855a1.928,1.928,0,0,0-1.928-1.928H13.592l-.363-.263C12.554,1.171,11.213-.014,10.281,0,9.349-.014,8.008,1.171,7.333,1.664l-.363.263H3.855A1.928,1.928,0,0,0,1.928,3.855V5.628c-.5.375-.834.637-1.189.916A1.928,1.928,0,0,0,0,8.061v.428l3.855,2.785V3.855H16.707v7.419l3.855-2.785V8.061a1.928,1.928,0,0,0-.739-1.517Z"
                        transform="translate(0 0)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Subscription</span>
              </router-link>
            </li>
            <li>
              <router-link to="/Me/Settings" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 20.05 20.05">
                  <path id="Icon_ionic-md-settings" data-name="Icon ionic-md-settings"
                        d="M21.014,14.4a6.27,6.27,0,0,0,.051-1c0-.351-.051-.652-.051-1l2.153-1.654a.46.46,0,0,0,.1-.652L21.218,6.633a.5.5,0,0,0-.615-.2l-2.563,1a7.462,7.462,0,0,0-1.743-1l-.359-2.656a.549.549,0,0,0-.513-.4h-4.1a.549.549,0,0,0-.513.4L10.4,6.432a8.682,8.682,0,0,0-1.743,1l-2.563-1a.48.48,0,0,0-.615.2L3.428,10.092a.605.605,0,0,0,.1.652l2.2,1.654c0,.351-.051.652-.051,1s.051.652.051,1L3.582,16.057a.46.46,0,0,0-.1.652L5.53,20.167a.5.5,0,0,0,.615.2l2.563-1a7.461,7.461,0,0,0,1.743,1l.41,2.656a.5.5,0,0,0,.513.4h4.1a.549.549,0,0,0,.513-.4l.411-2.656a8.677,8.677,0,0,0,1.743-1l2.563,1a.48.48,0,0,0,.615-.2l2.051-3.459a.6.6,0,0,0-.1-.652Zm-7.639,2.506A3.51,3.51,0,1,1,16.963,13.4,3.527,3.527,0,0,1,13.374,16.909Z"
                        transform="translate(-3.375 -3.375)" fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Settings</span>
              </router-link>
            </li>
            <li>
              <router-link to="/Me/Logout" :class="routerLinkClasses">
                <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" :class="navIconClasses" viewBox="0 0 20.562 17.992">
                  <path id="Icon_open-account-logout" data-name="Icon open-account-logout"
                        d="M7.711,0V2.57H17.992V15.422H7.711v2.57H20.562V0ZM5.141,5.141,0,9l5.141,3.855v-2.57H15.422V7.711H5.141Z"
                        fill="currentColor"/>
                </svg>

                <span :class="{'sr-only': !open}">Logout</span>
              </router-link>
            </li>
            <li>
              <div v-if="this.user.memberType === 'Free Trial'" class="trial-info">
                {{ this.user.subscription.remaining_projects }} Free Reports Remaining.<br><br>Expires
                On:<br>{{ this.user.trialEndDate }}
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../../services/Client/Auth';
import VueCollapsible from '../Shared/VueCollapsible.vue';
import StatusBlockCircle from '../Shared/StatusBlockCircle.vue';
import TagModalView from './TagModalView.vue';

export default {

  components: {VueCollapsible, StatusBlockCircle, TagModalView},

  props: {
    open: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      user: {},
      isLoggedIn: false,
      onUserProfile: false,
      projectTags: [],
      contactTags: [],
      showContactTagModal: false,
      showProjectTagModal: false,
    }
  },
  computed: {
    navIconClasses() {
      return this.open ? 'h-4 w-4 mx-2' : 'w-5'
    },
    routerLinkClasses() {
      return this.open ? 'flex items-center px-6 py-4' : 'flex items-center px-6 py-4 justify-center';
    }
  },

  mounted() {
    this.isLoggedIn = auth.isLoggedIn();
    this.user = auth.user
    this.setNavStyle(this.$route);
  },

  methods: {
    reloadTags() {

      this.showContactTagModal = false;
      this.showProjectTagModal = false;

      auth.getUserInfo();
    },

    setNavStyle(route) {

      if (route.meta && route.meta.user) {
        this.onUserProfile = true
      } else {
        this.onUserProfile = false
      }
    },

    editProjectTag(tag) {

      this.$refs.projectTag.openTag(tag);
      this.showProjectTagModal = true
    },

    editContactTag(tag) {

      this.$refs.contactTag.openTag(tag);
      this.showContactTagModal = true
    },

    toggleKeywordSearch() {
      let root = this.$parent.$el
      let search = root.querySelector('.search-bar')
      if (search) {
        search.classList.toggle('hidden');
      }
    },
  },

  watch: {
    '$root.$data.auth.user': {
      handler: function (val, oldVal) {
        this.contactTags = this.$root.$data.auth.user.contactTags;
        this.projectTags = this.$root.$data.auth.user.projectTags;
      },
      deep: true
    },

    '$route': function (route) {

      this.setNavStyle(route);
      this.isLoggedIn = auth.isLoggedIn();
    },
  },
}
</script>

<style>
.trial-info {
    padding: 10px;
    color: #fff;
    font-size: 18px;
    line-height: 20px;
    background-color: var(--primary-color1);
    margin-left: 12px;
    margin-right: 12px;
    border-radius: 5px;
    font-weight: 500;
    padding-top: 12px;
    padding-bottom: 12px;
}

nav .status-block-circle {
    opacity: 1.0;
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-top: 1px;
    margin-bottom: 0px;
}

nav .status-block-circle:hover,
nav .status-block-circle:hover:after {
    border: 0px;
}

nav .tag-link-wrapper {
    position: relative;
}

nav .tag-link {
    vertical-align: middle;
}

nav .tag-link-edit {
    background: #FFF;
    color: #4A4A4A;
    display: none;
    font-size: 12px;
    border-radius: 3px;
    border: 1px solid #E8E8E8;
    padding: 3px 5px;
    cursor: pointer;
}

nav .tag-link-wrapper:hover .tag-link-edit {
    display: block;
}
</style>

